import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import arrowIcon from "../../assets/right-arrow.png";
import useMembersStore from "../../store/members.store";
import { Tooltip } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";

import "./qhrsetsidebar.scss";

function QHRSETSidebar() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isSticky, setIsSticky] = useState(false);

  const [isCollapsedTeam, setIsCollapsedTeam] = useState();
  const [isCollapsedMy, setIsCollapsedMy] = useState(true);
  const [isCollapsedAllResume, setIsCollapsedAllResume] = useState(true);
  const [isCollapsedInterviews, setIsCollapsedInterviews] = useState(true);
  const [isCollapsedSourcing, setIsCollapsedSourcing] = useState(true);
  const [isCollapsedJD, setIsCollapsedJD] = useState(true);
  const { currSubscription } = useMembersStore();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));


  const [isCollapsedJDrs, setIsCollapsedJDrs] = useState(true);
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".navbar-wrapper");
      const breadcrumb = document.querySelector(".breadcrumbs");
      const headerHeight =
        header?.offsetHeight + breadcrumb?.offsetHeight || 80;

      if (window.scrollY > headerHeight) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleToggleCollapseTeam = () => {
    setIsCollapsedTeam(!isCollapsedTeam);
  };
  const handleToggleCollapseMy = () => {
    setIsCollapsedMy(!isCollapsedMy);
  };
  const handleToggleCollapseAllResume = () => {
    setIsCollapsedAllResume(!isCollapsedAllResume);
  };
  const handleToggleCollapseInterviews = () => {
    setIsCollapsedInterviews(!isCollapsedInterviews);
  };
  const handleToggleCollapseSourcing = () => {
    setIsCollapsedSourcing(!isCollapsedSourcing);
  };
  const handleToggleCollapsejd = () => {
    setIsCollapsedJD(!isCollapsedJD);
  };

  const handleToggleCollapsers = () => {
    setIsCollapsedJDrs(!isCollapsedJDrs);
  };

  const setStatus = (data) => {
    localStorage.setItem("status", JSON.stringify({ status: data }));
  };

  function getTimeNow(){
    const today = new Date();
    const month = today.getMonth()+1;
    const year = today.getFullYear();
    const date = today. getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate
  }

  function getDay(){
    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]; 
    const today = new Date();
    const day = today.getDay();
    return weekday[day]
  }

  return (
    <>
      <div
        className="qhrsetsidebar-wrapper"
      >
        {/* <Link className="sidebar-link" to="/interviews">
                Job Descriptions
            </Link> */}

        <Link
          className="qhrsetsideFont"
          style={{ marginLeft: "20px",marginTop: "20px" }}
        >
          {getDay()}
          <br></br> {getTimeNow()}
        </Link>

      {/* <Link className="sidebar-link" to="/My Assignments">
                Dashboard
            </Link> */}
      <div>
          <hr></hr>
        <button
            className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
            isCollapsedTeam ? "" : "active" // Add the active class conditionally
          } sideFont`}
          style={{ color: "white" }}
          onClick={handleToggleCollapseTeam}
          data-bs-toggle="collapse"
          data-bs-target="#home-collapse"
          aria-expanded={isCollapsedTeam ? "false" : "true"}
        >
          <img
            src={arrowIcon}
            alt="Arrow"
            width="8" height="8" 
            className={`arrow-icon me-2 ${isCollapsedTeam ? "" : "rotate"}`}
          />
          My Dashboard
        </button>

        {!isCollapsedTeam && (
          <ul id="home-collapse" className="listShow">
            <li className="list-group-item">
              <Link
                className="sidebar-link"
                to={{ pathname: "/qsethome/qsetdashboard" }}
                onClick={() => setStatus("active")}
              >
                Evaluations
              </Link>
            </li>    
            <li className="list-group-item">
              <Link
                className="sidebar-link"
                  to={{ pathname: "/qsethome/qsetjdview" }}
                onClick={() => setStatus("active")}
              >
                JD
              </Link>
            </li>                    

            <li className="list-group-item">
              <Link
                className="sidebar-link listShow"
                onClick={() => setStatus("active")}
                to={{ pathname: "/qsethome/qsetcandidateprofile" }}
              >
                My Application
              </Link>
            </li>                                                         
            {/* Add more list items as needed */}
          </ul>
        )}
        <hr></hr>
      </div>
    </div>
    </>
  );
}

export default QHRSETSidebar;
